import { apiInstance } from "./apiService"

export function fetchZipCityCountyRegion() {
    return apiInstance("./assets/zip-city-county-region.js")
}
